import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withFirebase } from "../../Firebase";
import IconPlus from "../../../assets/cards/icon_plus.svg";
import IdeaCardB from "../IdeaCard";

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import '../ChallengePage.css';

class IdeaSectionComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUserId: '',
      ideas: this.props.ideas,
      filterByRelevance: false,
      sortedIdeas: [],
      sortedIdeasByDate: [],
      sortedIdeasByRelevance: []
    };
  }

  componentDidMount() {
    this.setState({
      currentUserId: this.props.firebase.auth.currentUser.uid
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      ideas: nextProps.ideas,
      sortedIdeas: this.sortIdeasByDate(this.props.ideas),
    })

  }

  sortIdeasByRelevance = (ideas) => {
    let sortedIdeasByRelevance = JSON.parse(JSON.stringify(ideas))
    sortedIdeasByRelevance.forEach(idea => {
      const { capsuleId } = this.props
      let sortingScore = 10 // starts at 10 but can go to 20
      let nbUsersCompany = localStorage.getItem("nbUsersCompany")

      sortingScore += idea.nbLikes / (0.02 * nbUsersCompany) //adds a point every 5% of likes
      sortingScore += idea.comments ? idea.comments.length : 0 //adds a point for every comment

      let finalScore = sortingScore > 20 ? 20 : sortingScore < 0 ? 0 : sortingScore

      if (!idea.sortingScore || idea.sortingScore !== finalScore) {
        this.props.firebase.db.collection('capsules').doc(capsuleId).collection('ideas').doc(idea.id).update({ sortingScore: finalScore })
      }

      idea.sortingScore = sortingScore > 20 ? 20 : sortingScore < 0 ? 0 : sortingScore

    })
    sortedIdeasByRelevance.sort((ideaA, ideaB) => ideaB.sortingScore - ideaA.sortingScore)
    return sortedIdeasByRelevance
  }

  sortIdeasByDate = (ideas) => {
    let sortedIdeasByDate = JSON.parse(JSON.stringify(ideas))
    sortedIdeasByDate.sort((ideaA, ideaB) => ideaB.time - ideaA.time)
    return sortedIdeasByDate
  }

  changeIdeaFilter = () => {
    const { filterByRelevance } = this.state
    if (filterByRelevance) {
      this.setState({ filterByRelevance: false, sortedIdeas: this.sortIdeasByDate(this.props.ideas) })
    }
    else {
      this.setState({ filterByRelevance: true, sortedIdeas: this.sortIdeasByRelevance(this.props.ideas) })
    }
  };

  updateComments = (idea, comments) => {
    let { sortedIdeas, ideas } = this.state
    sortedIdeas.forEach(sortedIdea => {
      if (sortedIdea.id === idea.id) {
        sortedIdea.comments = comments
      }
    })
    ideas.forEach(stateIdea => {
      if (stateIdea.id === idea.id) {
        stateIdea.comments = comments
      }
    })
    this.setState({ sortedIdeas, ideas })
  }

  render() {
    const { capsule, capsuleId } = this.props
    const { sortedIdeas, currentUserId } = this.state
    let displayReactivate = capsule.status ? capsule.status === 'finish' : false

    return (
      <>
        <div className="text-center pt-3">
          <h1 className="cps-title">Les Idées</h1>
          <button
            className="button-challenge"
            type="button"
            onClick={() => this.props.openIdea()}
          >
            <img alt="icon" className="img-btn-two" src={IconPlus} />
            Ajouter une Idée
          </button>
        </div>
        <div className="d-flex idea-list">
          {
            sortedIdeas.map((idea, index) => (

              <div className="center-with-padding" key={index}>
                <IdeaCardB
                  index={index + 1}
                  idea={idea}
                  idCard={idea.id}
                  idCapsule={capsuleId}
                  canAddComment={true}
                  canAddLike={true}
                  updateComments={this.updateComments}
                />
              </div>))
          }
        </div>


        <div className="d-flex justify-content-center">
          <MuiThemeProvider theme={theme}>
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.filterByRelevance}
                  onChange={() => this.changeIdeaFilter()}
                  value="filterChecked"
                  color="primary"
                />
              }
              label="Tri par pertinence"
            />
          </MuiThemeProvider>
        </div>

        <div className="align-flex">
          <button hidden={!(displayReactivate && capsule.creator === currentUserId)} onClick={() => this.props.onReopen()} className="reopen-button">Réactiver</button>
          <button hidden={capsule.creator !== currentUserId} onClick={() => this.props.openDelete()} className="delete-button">Supprimer la capsule</button>
        </div>
      </>
    );
  }
}

const theme = createMuiTheme({
  palette: {
    primary: { main: '#0070A2' },
  },
  typography: { useNextVariants: true },
});

const IdeaSection = withRouter(withFirebase(IdeaSectionComponent));

export default IdeaSection;
